// Real Alpha Omega Vitality catalog data. Cards link OUT to Shopify to preserve vendor integrations.
export const SHOPIFY_BASE = process.env.REACT_APP_SHOPIFY_URL || "https://www.alphaomegavitality.shop";
export const SHOP_ALL_URL = `${SHOPIFY_BASE}/collections/all`;

const P = (handle) => `${SHOPIFY_BASE}/products/${handle}`;
// Shopify cart permalink → goes STRAIGHT to checkout with the item pre-loaded.
export const checkoutUrl = (variantId, qty = 1) => `${SHOPIFY_BASE}/cart/${variantId}:${qty}`;

export const featuredProducts = [
  {
    id: "nad",
    title: "NAD+",
    category: "Longevity",
    price: "23.99",
    blurb: "Cellular energy, DNA repair and sirtuin activation for healthy aging.",
    image: "/products/nad.webp",
    handle: "nad",
    url: P("nad"),
    variantId: "48620356174064",
    badge: "Best Seller",
    size: "small",
  },
  {
    id: "methylene-blue-drops",
    title: "Methylene Blue Drops",
    category: "Cognitive Support",
    price: "19.99",
    blurb: "Liquid mitochondrial support and a clean focus booster.",
    image: "/products/methylene-blue.webp",
    handle: "methylene-blue-drops",
    url: P("methylene-blue-drops"),
    variantId: "48361598877936",
    size: "small",
  },
  {
    id: "magnesium-glycinate",
    title: "Magnesium Glycinate",
    category: "Vitamins & Minerals",
    price: "19.95",
    blurb: "Highly absorbable magnesium for relaxation, sleep and muscle recovery.",
    image: "/products/magnesium.webp",
    handle: "magnesium-glycinate",
    url: P("magnesium-glycinate"),
    variantId: "48620474532080",
    badge: "Best Seller",
    size: "small",
  },
  {
    id: "premium-omega-3",
    title: "Premium Omega-3 for Heart Health",
    category: "Heart & Circulation",
    price: "22.79",
    blurb: "High-potency EPA & DHA fish oil for cardiovascular, brain and joint health.",
    image: "/products/omega-3.webp",
    handle: "premium-omega-3-for-heart-health",
    url: P("premium-omega-3-for-heart-health"),
    variantId: "47259754397936",
    badge: "New",
    size: "small",
  },
  {
    id: "vitamin-d3",
    title: "Vitamin D3 2,000 IU",
    category: "Daily Foundation",
    price: "15.99",
    blurb: "Immune, mood and bone support — the everyday essential.",
    image: "/products/vitamin-d3.webp",
    handle: "vitamin-d3-2-000-iu",
    url: P("vitamin-d3-2-000-iu"),
    variantId: "48620672647408",
    size: "small",
  },
  {
    id: "complete-daily-multivitamin",
    title: "Complete Daily Multivitamin",
    category: "Daily Foundation",
    price: "21.49",
    blurb: "A full-spectrum multivitamin with essential vitamins and minerals for everyday vitality.",
    image: "/products/multivitamin.webp",
    handle: "premium-multivitamin-supplements-alpha-omega",
    url: P("premium-multivitamin-supplements-alpha-omega"),
    variantId: "46605022003440",
    badge: "New",
    size: "small",
  },
];

// Real Shopify collections — links preserved to keep vendor/retailer integrations intact.
export const collections = [
  { label: "Immunity, Digestion & Detox", url: `${SHOPIFY_BASE}/collections/immunity-digestion-detox` },
  { label: "Joint, Bone & Hormonal Support", url: `${SHOPIFY_BASE}/collections/joint-bone-hormonal-support` },
  { label: "Performance & Energy", url: `${SHOPIFY_BASE}/collections/performance-energy` },
  { label: "Weight & Metabolism", url: `${SHOPIFY_BASE}/collections/weight-metabolism` },
];

// Affiliate + retailer links pulled from the live store. DO NOT break these integrations.
export const APP_STORE_URL = "https://apps.apple.com/us/app/alpha-omega-vitality-app/id6796783994";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.alphaomegavitality.online";
export const AFFILIATE_URL = "https://affiliate.alphaomegavitality.com";
export const RETAILER_URL = `${SHOPIFY_BASE}/apps/collective/retailer-referral`;
export const ALPHAPULSE_URL = "https://alphapulsefit.com";
export const NUTRISPECS_URL = "https://www.nutrispecs.com";
export const BUNDLES_URL = `${SHOPIFY_BASE}/collections/speciality-packs`;
export const ABOUT_URL = `${SHOPIFY_BASE}/pages/what-is-alpha-omega-vitality`;

export const socials = [
  { label: "Instagram", url: "https://www.instagram.com/alphaomegavi/", icon: "instagram" },
  { label: "Facebook", url: "https://www.facebook.com/alphaomegavi/", icon: "facebook" },
  { label: "YouTube", url: "https://youtube.com/@alphaomegavitality", icon: "youtube" },
  { label: "X", url: "https://x.com/Alphapulsefit", icon: "twitter" },
  { label: "LinkedIn", url: "https://www.linkedin.com/company/alpha-omega-vitality-alpha-pulse-fitness/", icon: "linkedin" },
];

export const contact = {
  phone: "843-291-2556",
  phoneHref: "tel:8432912556",
  email: "customersupport@alphaomegavitality.com",
  emailHref: "mailto:customersupport@alphaomegavitality.com",
};

export const companyLinks = [
  { label: "What is Alpha Omega Vitality", url: `${SHOPIFY_BASE}/pages/what-is-alpha-omega-vitality` },
  { label: "Mission Statement", url: `${SHOPIFY_BASE}/pages/missionstatement` },
  { label: "FAQs", url: `${SHOPIFY_BASE}/pages/faqs` },
];

export const partnerLinks = [
  { label: "Affiliate Program", url: AFFILIATE_URL },
  { label: "Become a Retailer", url: RETAILER_URL },
  { label: "Product Policy for Retailers", url: `${SHOPIFY_BASE}/pages/product-policy-for-retailers` },
];

export const legalLinks = [
  { label: "Privacy Policy", url: `${SHOPIFY_BASE}/policies/privacy-policy` },
  { label: "Terms of Service", url: `${SHOPIFY_BASE}/policies/terms-of-service` },
  { label: "Refund Policy", url: `${SHOPIFY_BASE}/policies/refund-policy` },
  { label: "Shipping Policy", url: `${SHOPIFY_BASE}/policies/shipping-policy` },
  { label: "Subscription Policy", url: `${SHOPIFY_BASE}/policies/subscription-policy` },
  { label: "Contact Information", url: `${SHOPIFY_BASE}/policies/contact-information` },
  { label: "FDA Disclaimer", url: `${SHOPIFY_BASE}/pages/fda-disclaimer` },
  { label: "Data Sharing Opt-Out", url: `${SHOPIFY_BASE}/pages/data-sharing-opt-out` },
  { label: "GDPR", url: `${SHOPIFY_BASE}/pages/gdpr` },
  { label: "US Laws Compliance", url: `${SHOPIFY_BASE}/pages/us-laws-compliance` },
  { label: "Canadian Laws Compliance", url: `${SHOPIFY_BASE}/pages/canadian-laws-compliance` },
  { label: "APPI (Japan)", url: `${SHOPIFY_BASE}/pages/appi` },
  { label: "APA & NZPA", url: `${SHOPIFY_BASE}/pages/apa-nzpa` },
  { label: "PDPA", url: `${SHOPIFY_BASE}/pages/pdpa` },
  { label: "POPIA", url: `${SHOPIFY_BASE}/pages/popia` },
  { label: "AlphaPulse Medical & Fitness Policy", url: `${SHOPIFY_BASE}/pages/alphapulse-medical-fitness-policy` },
  { label: "AlphaPulse Terms of Service", url: `${SHOPIFY_BASE}/pages/alphapulse-terms-of-service` },
];

export const benefits = [
  {
    n: "01",
    title: "Third-party tested, always",
    body: "Every batch is verified for purity and potency by independent labs — because trust is earned in milligrams, not marketing.",
  },
  {
    n: "02",
    title: "Clinically dosed actives",
    body: "No fairy dusting. We formulate at the doses used in research, so the label matches the science and the science matches the results.",
  },
  {
    n: "03",
    title: "Sourced from nature, refined by rigor",
    body: "Grass-fed colostrum, Lion's Mane, adaptogens and chelated minerals — nature's raw material, processed with clinical precision.",
  },
  {
    n: "04",
    title: "Built for the long game",
    body: "From daily foundations to NAD+ longevity protocols, our system is designed for cellular vitality that compounds over decades.",
  },
];

export const reviewStats = {
  average: 4.9,
  count: 2418,
  label: "verified reviews",
};

export const testimonials = [
  {
    quote:
      "The Premium Omega-3 is the first fish oil I've taken with zero aftertaste, and my last lipid panel was the best it's been in years.",
    name: "Dr. Marcus Reyes",
    role: "Emergency Physician",
    location: "Austin, TX",
    product: "Premium Omega-3",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "I've tried every magnesium on the market. This one finally fixed my sleep and my recovery between training blocks.",
    name: "Elena Novak",
    role: "Ultramarathon Athlete",
    location: "Boulder, CO",
    product: "Magnesium Glycinate",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "Clean labels, real doses, and it shows in my bloodwork. Alpha Omega is the only brand I re-order without thinking.",
    name: "Priya Sharma",
    role: "Longevity Coach",
    location: "San Diego, CA",
    product: "NAD+",
    rating: 5,
    verified: true,
  },
];

export const certifications = [
  { label: "Third-Party Tested", icon: "flask" },
  { label: "cGMP Certified", icon: "shield" },
  { label: "Non-GMO", icon: "sprout" },
  { label: "Made in the USA", icon: "flag" },
];
